<template>
  <div class="device-item-box">
    <dl class="info-list">
      <dt class="device-title">
        <span class="device-name">{{ deviceName }} </span>
        <em v-if="isCurrentDevice" class="mark">현재 디바이스</em>
      </dt>
      <dd class="device-info">
        <div class="profile-info">
          <i
            class="profile-image"
            :style="profileImage && { backgroundImage: `url(${profileImage})` }"
          />
          <span class="profile-name">{{ profileName }}</span>
        </div>
      </dd>
      <dd class="device-info">
        <span>최근 이용시간</span>
        <span :class="['date', { 'date-separator': usedDate }]">{{
          usedDateComp
        }}</span>
      </dd>
      <dd class="device-info">
        <span>최초 로그인</span>
        <span :class="['date', { 'date-separator': loginDate }]">{{
          loginDateComp
        }}</span>
      </dd>
    </dl>
    <button type="button" class="logout-button" @click="$emit('click-logout')">
      로그아웃
    </button>
  </div>
</template>

<script setup>
  import { computed } from 'vue'
  import { getLocalDate, getLocalTime } from '@/common/util/date'

  const props = defineProps({
    deviceName: {
      type: String,
      default: '-',
    },
    profile: {
      type: Object,
      default: () => ({}),
    },
    usedDate: {
      type: String,
      default: '',
    },
    loginDate: {
      type: String,
      default: '',
    },
    isCurrentDevice: {
      type: Boolean,
      default: false,
    },
  })

  const emit = defineEmits(['click-logout'])

  const profileImage = computed(() => {
    const profileImageUrl = props.profile?.profileImage
    if (!profileImageUrl || profileImageUrl === '') {
      return
    }
    return props.profile?.profileImage
  })

  const profileName = computed(() => {
    return props.profile?.name || '-'
  })

  const loginDateComp = computed(() => {
    if (!props.loginDate) {
      return '-'
    }
    const date = new Date(props.loginDate)
    return getLocalDate(date)
  })

  const usedDateComp = computed(() => {
    if (!props.usedDate) {
      return '-'
    }
    const date = new Date(props.usedDate)
    return `${getLocalDate(date)} ${getLocalTime(date, { second: false })}`
  })
</script>

<style lang="scss" scoped>
  .device-item-box {
    position: relative;
    padding-right: 84px;
    .logout-button {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      padding: 6px 12px;
      border-radius: 24px;
      background-color: #2f2f2f;
      font-size: 10px;
      color: #fff;
      line-height: 14px;
    }
  }
  .info-list {
    padding: 0 0 0 52px;
    .device-title {
      display: flex;
      align-items: center;
      .device-name {
        font-size: 16px;
        color: #fff;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-break: break-all;
      }
      .mark {
        flex: none;
        padding: 3px;
        margin-left: 4px;
        border-radius: 4px;
        border: 1px solid #3887ff;
        background-color: rgba(0, 0, 0, 0.8);
        font-size: 10px;
        font-style: normal;
        font-weight: 700;
        color: #3887ff;
        line-height: 12px;
        vertical-align: top;
      }
    }
    .device-info {
      position: relative;
      margin-top: 4px;
      font-size: 12px;
      color: #a5a5a5;
      line-height: 18px;
    }
    .device-info .profile-info {
      position: relative;
    }
    .device-info .profile-info .profile-image {
      overflow: hidden;
      position: absolute;
      right: 100%;
      top: -24px;
      width: 44px;
      height: 44px;
      margin-right: 8px;
      background-image: url('~@/assets/images/profile/none.png');
      background-size: 44px auto;
      border-radius: 50%;
      vertical-align: top;
    }
    .device-info .profile-info .profile-name {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
    }
    .device-info .date {
      position: relative;
      padding-left: 10px;
    }
    .device-info .date-separator:before {
      position: absolute;
      left: 4px;
      top: 8px;
      height: 100%;
      width: 2px;
      height: 2px;
      background-color: #a5a5a5;
      border-radius: 50%;
      content: '';
    }
  }
</style>
